var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBlackRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7075 9.04011C22.0981 8.64959 22.0981 8.01643 21.7075 7.6259L15.3436 1.26194C14.953 0.871416 14.3199 0.871416 13.9294 1.26194C13.5388 1.65246 13.5388 2.28563 13.9294 2.67615L19.5862 8.33301L13.9294 13.9899C13.5388 14.3804 13.5388 15.0136 13.9294 15.4041C14.3199 15.7946 14.953 15.7946 15.3436 15.4041L21.7075 9.04011ZM0.130859 9.33301H21.0004V7.33301H0.130859V9.33301Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlackRight);
export default __webpack_public_path__ + "static/media/arrow-black-right.be3960c5049b378fece98be2e641b6cc.svg";
export { ForwardRef as ReactComponent };